<template>
  <div>
    <section class="p-box">
      <Loading v-show="loading" />
      <template v-if="!loading">
        <div class="p-box__header">
          <div class="linkToIndex">
            <router-link class="c-button__item c-button__item--outline" :to="{ name: 'CompaniesProducts', params: { companyUuid: companyUuid } }">
              {{ $t("pages.CompaniesProduct.linkToIndex") }}
            </router-link>
          </div>
        </div>
        <div class="p-box__body">
          <div class="c-grid">
            <div class="c-grid__items">
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__8 c-grid__item__l__8">
                <div class="p-product">
                  <div class="p-product__header">
                    <div
                      class="p-photos__image"
                    >
                      <div :style="{ 'background-image': `url(${ product.image })`, 'background-size': 'contain' }" />
                    </div>
                  </div>
                  <div class="p-product__summary">
                    <div class="p-product__name">
                      {{ product.title }}
                    </div>
                    <div class="p-product__category">
                      {{ product.categoryName }}
                    </div>
                    <div class="p-product__description">
                      {{ product.description }}
                    </div>
                    <div v-if="product.price" class="fontBold">
                      {{ numberLocaleString(product.price.value) }}円
                    </div>
                  </div>
                  <div v-if="showMoreThanEditorAuthority && product.gmbSyncResult.status !== 'syncing' && product.editable" class="p-product__action">
                    <div>
                      <router-link :to="{ name: 'CompaniesProductEdit', params: { company_uuid: companyUuid, id: productId }}" class="actionButton">
                        <Icon name="iconPencil" />
                        {{ $t('pages.CompaniesProducts.edit') }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__4 c-grid__item__l__4">
                <div class="p-box storeSummary__container">
                  <div class="p-box__body">
                    <h3 class="p-box__title storeSummary__title">{{ $t("pages.CompaniesProduct.statusOfUse") }}</h3>
                    <div class="storeSummary__count">
                      {{ $t('pages.CompaniesProduct.totalStoreCount') }}：
                      <UnUsedBadge v-if="product.registeredStoreCount === 0" />
                      <a v-else class="storeSummary__value">{{ $t('labels.simpleStoresCount', { count: product.registeredStoreCount }) }}</a>
                    </div>
                    <div v-if="product.gmbSyncResult.status === 'failed'" class="storeSummary__count status">
                      <span class="status__circle--failed" />
                      <span class="storeSummary__value">{{ $t('labels.errorAtStores', { count: product.gmbSyncResult.error_count }) }}</span>
                    </div>
                    <Info v-if="showMoreThanEditorAuthority && product.editable">
                      <p>
                        {{ $t('pages.CompaniesProduct.info') }}
                      </p>
                      <p>
                        <span class="deleteProduct" @click.prevent="handleDelete">
                          {{ $t('pages.CompaniesProduct.deleteProduct') }}
                        </span>
                      </p>
                    </Info>
                  </div>
                </div>
              </div>
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                <div id="storeTable" class="p-table">
                  <Loading v-show="loading" />
                  <div class="storesTable__header">
                    <div class="storesTable__storeCount">
                      {{ $t('pages.CompaniesProduct.storeCount', { count: productStores.length }) }}
                    </div>
                    <div v-if="showMoreThanEditorAuthority && product.editable" class="storesTable__storeCount">
                      <button
                        class="c-button__item c-button__item--primary"
                        @click="handleBulkSetStore"
                      >
                        {{ $t('pages.CompaniesProduct.bulkSet') }}
                      </button>
                    </div>
                  </div>
                  <template v-if="productStores.length !== 0">
                    <div class="p-table__content">
                      <table>
                        <thead>
                          <tr>
                            <th><span>{{ $t('labels.store') }}</span></th>
                            <th><span>{{ $t('labels.url') }}</span></th>
                            <th><span>{{ $t('labels.productStatus') }}</span></th>
                            <th><span>{{ $t('labels.status') }}</span></th>
                            <th v-if="showMoreThanEditorAuthority"><span>{{ $t('labels.operation') }}</span></th>
                          </tr>
                          <tr class="p-table__content__space"><td colspan="5" /></tr>
                        </thead>
                        <tbody>
                          <template v-if="productStores.length !== 0">
                            <tr v-for="store in productStores" :key="`store_${store.id}`">
                              <td class="storesTable__storeName">{{ store.storeName }}</td>
                              <td class="storesTable__storeUrl">{{ store.optionButtonUrl ? store.optionButtonUrl : '-' }}</td>
                              <td>
                                <div class="storesTable__productStatus">
                                  <Icon name="iconGmb" class="storesTable__productStatus__icon" />
                                  {{ $t('pages.CompaniesProduct.gmb') }}
                                </div>
                              </td>
                              <td class="status">
                                <span :class="`status__circle--${ store.gmbSyncStatus.kind }`" />
                                <span v-if="store.gmbSyncStatus.kind === 'failed'">
                                  <router-link :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: store.uuid} }" class="status failed">
                                    {{ $t('pages.CompaniesProduct.hasError') }}
                                  </router-link>
                                </span>
                                <span v-else>
                                  {{ $t('pages.CompaniesProduct.status.' + store.gmbSyncStatus.kind ) }}
                                </span>
                              </td>
                              <td v-if="showMoreThanEditorAuthority">
                                <div class="storesTable__operation">
                                  <span v-if="store.gmbSyncStatus.kind === 'synced' || store.gmbSyncStatus.kind === 'failed'" class="storesTable__action" @click="onDeleteProductStore(store)">
                                    <Icon name="iconCross" class="storesTable__action__icon" />
                                    {{ $t('pages.CompaniesProduct.cancel') }}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </template>
                          <div v-else class="noStores" v-text="$t('messages.noData')" />
                        </tbody>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <StoreCountFilterModal
        v-if="showStoreCountFilterModal"
        @close="handleCloseFilterModal"
        @submit="handleSubmit"
        @reset="handleReset"
      />
      <StoreModal
        v-if="showStoreModal"
        store-name="companiesProduct"
        @close-store-modal="handleStoreUpdate"
        @back-filter-modal="handleBack"
      />
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import Loading from '../../../components/Loading'
import Icon from '../../../components/Icon'
import UnUsedBadge from '../../../components/CompaniesMediaLibraries/UnUsedBadge'
import Info from '../../../components/Info.vue'
import StoreModal from '../../../components/StoreModal'
import StoreCountFilterModal from '../../../components/StoreCountFilterModal'
import { toNumberLocaleString } from '../../../modules/localeString'

export default {
  name: 'CompaniesProduct',
  components: {
    Loading,
    Icon,
    UnUsedBadge,
    Info,
    StoreModal,
    StoreCountFilterModal
  },
  data() {
    return {
      showStoreCountFilterModal: false,
      showStoreModal: false
    }
  },
  computed: {
    ...mapState({
      product: state => state.companiesProduct.data,
      formValues: state => state.companiesProduct.formValues,
      productStores: state => state.companiesProduct.data.productStores,
      productLoading: state => state.companiesProduct.loading,
      selectStoresLoading: state => state.companiesGmbSearchStores.loading || state.companiesSearchTagGroups.loading,
      searchAttributesLoading : state => state.companiesSearchTagGroups.loading,
      brands: state => state.companiesSearchTagGroups.data.brands,
      franchisees: state => state.companiesSearchTagGroups.data.franchisees,
      areas: state => state.companiesSearchTagGroups.data.areas,
      userCompanies: state => state.companiesSearchTagGroups.data.user_companies,
      prefectures : state => state.companiesSearchTagGroups.data.prefectures,
      originalTagGroupA : state => state.companiesSearchTagGroups.data.original_tag_group_a,
      originalTagGroupB : state => state.companiesSearchTagGroups.data.original_tag_group_b,
      originalTagGroupC : state => state.companiesSearchTagGroups.data.original_tag_group_c,
      originalTagGroupD : state => state.companiesSearchTagGroups.data.original_tag_group_d,
      originalTagGroupE : state => state.companiesSearchTagGroups.data.original_tag_group_e,
    }),
    ...mapGetters({
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    productId() {
      return this.$route.params.id
    },
    loading() {
      return this.productLoading | this.selectStoresLoading | this.searchAttributesLoading
    },
  },
  async created(){
    this.readProduct(this.productId)
    await this.readSearchTagGroups()
    this.readStores({companyUuid: this.companyUuid, formValues: {}})
    this.setGmbSearchAttributesFormStoreValues(this.formInitialValues())
  },
  methods: {
    ...mapActions({
      readProduct: 'companiesProduct/readProduct',
      deleteProductStore: 'companiesProduct/deleteProductStore',
      deleteProduct: 'companiesProducts/deleteProduct',
      readStores: 'companiesGmbSearchStores/readStores',
      readSearchTagGroups: 'companiesSearchTagGroups/readSearchTagGroups',
      createProductStores: 'companiesProductBulkOperations/createProductStores',
    }),
    ...mapMutations({
      setFormValues: 'companiesProduct/setFormValues',
      setGmbSearchAttributesFormStoreValues: 'companiesSearchTagGroups/setFormValues',
    }),
    handleCloseFilterModal() {
      this.setFormValues({ stores: [...this.formValues.stores] })
      this.showStoreCountFilterModal = false
    },
    handleBulkSetStore() {
      if (this.formValues.stores.length !== 0) {
        this.showStoreModal = true
      } else {
        this.showStoreCountFilterModal = true
      }
    },
    async onDeleteProductStore(store) {
      if(!confirm(this.$t('pages.CompaniesProduct.confirmToDeleteProductStore', { storeName: store.storeName }))) return

      const isSuccess = await this.deleteProductStore(store.id)
      if(!isSuccess) return

      this.readProduct(this.productId)
    },
    async handleDelete() {
      if (confirm(this.$t('pages.CompaniesProduct.confirmToDelete'))) {
        if (await this.deleteProduct(this.productId)) this.$router.push({ name: 'CompaniesProducts', params: { company_uuid: this.companyUuid } })
      }
    },
    async handleStoreUpdate(storeUuids) {
      const payload =  {
        product_ids: [this.productId],
        store_uuids: storeUuids,
      }
      const isSuccess = await this.createProductStores(payload)
      if (isSuccess) this.readProduct(this.productId)
      this.showStoreModal = false
    },
    handleSubmit() {
      this.showStoreCountFilterModal = false
      this.showStoreModal = true
    },
    handleReset() {
      this.showStoreCountFilterModal = false
    },
    handleBack() {
      this.showStoreModal = false
      this.showStoreCountFilterModal = true
    },
    formInitialValues() {
      return {
        brands: this.brands.tags.map(v => v.id),
        franchisees: this.franchisees.tags.map(v => v.id),
        areas: this.areas.tags.map(v => v.id),
        user_companies: this.userCompanies.tags.map(v => v.id),
        prefectures: this.prefectures.tags.map(v => v.id),
        original_tag_group_a: this.originalTagGroupA?.tags.map(v => v.id),
        original_tag_group_b: this.originalTagGroupB?.tags.map(v => v.id),
        original_tag_group_c: this.originalTagGroupC?.tags.map(v => v.id),
        original_tag_group_d: this.originalTagGroupD?.tags.map(v => v.id),
        original_tag_group_e: this.originalTagGroupE?.tags.map(v => v.id)
      }
    },
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';
.fontBold {
  font-weight: bold;
}
.linkToIndex {
  margin-left: auto;
}
.p-product {
  display: flex;
  padding: 20px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  &__header {
    width: 25%;
    margin-right: 15px;
  }
  &__summary {
    width: 60%;
  }
  &__action {
    margin: auto 0;
    white-space: nowrap;
  }
  &__name {
    font-weight: bold;
  }
  &__categoryName {
    font-size: 12px;
  }
  &__description {
    margin: 10px 0;
    font-size: 12px;
    padding-right: 24px;
  }
}
.link {
  display: inline-block;
  margin-top: 16px;
  padding: 8px 24px;
  color: #3A3B3F;
  background: #EEEEEE;
  border-radius: 4px;
  text-decoration: none;
}
.actionButton {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  text-decoration: none;
  cursor: pointer;
  svg {
    margin-right: 10px;
  }
}
.deleteProduct {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
.storeSummary {
  &__container {
    height: 100% !important;
  }
  &__title {
    margin-bottom: 16px;
  }
  &__count {
    margin-bottom: 16px;
  }
  &__value {
    font-weight: bold;
    color: $color-accent-primary;
  }
}
.status {
  %__circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 100%;
  }
  &__circle {
    &--syncing {
      @extend %__circle;
      background: #D2D5DB;
    }
    &--synced {
      @extend %__circle;
      background: $complete-color;
    }
    &--failed {
      @extend %__circle;
      background: $color-accent-primary;
    }
    &--deleting {
      @extend %__circle;
      background: #D2D5DB;
    }
  }
  .failed {
    color: $color-accent-primary;
    text-decoration: underline;
    cursor: pointer;
  }
}
.storesTable {
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__storeCount {
    margin-bottom: 16px;
    font-weight: 700;
    display: inline-flex;
    align-items: flex-end;
  }
  &__storeName {
    width: 30%;
    background-color: $color-base-i;
  }
  &__storeUrl {
    width: 30%;
    word-break: break-all;
  }
  &__productStatus{
    display: flex;
    align-items: center;
    &__icon {
      margin: 4px 8px 0 0;
    }
  }
  &__operation {
    display: flex;
  }
  &__action {
    display: flex;
    cursor: pointer;
    &__icon {
      margin: 4px 8px 0 0;
    }
  }
}
</style>
